import React , {  useState } from "react"
import { useNavigate } from "react-router-dom";
import { useAuthUser } from "../auth"

export const  LoginComponent = () =>{

    const { login } = useAuthUser();
    const [form, formSet ] = useState({ userName : "", password : "" })
    const [classAlert, setClassAlert] = useState("alert-info");
    const [message, setMessage] = useState("veuillez rentrer vos identifiants")

    const handleInputChange = (event) =>
    {
        const value = event.target.value;
        const name = event.target.name;

        formSet({ ... form , [name] : value  })
    }

    const handleLogin = (event) => {

        event.preventDefault();

        if (form.userName && form.password) { 
            login(form.userName, form.password)
                .then(r => {
                    if (r) {
                        
                    }
                    else {
                        setClassAlert("alert-danger");
                        setMessage("vous n'avez pas le droit de vous connecter à pocahontas")
                    }
                })
        }
    }


    return <div className="row justify-content-center">
        <div className="card row-cols col-6">
            <form onSubmit={ handleLogin }>
                <div className="card-header row justify-content-center"><h3>Veuillez vous identifier</h3></div>
                <div className="card-body">
                <div className={"alert " + classAlert} >{ message }</div>
               <div className="form-group" > <label className="form-label">userName</label>
                <input type="email" name="userName" className="form-control" value={form.userName} required onChange={handleInputChange} ></input></div>
                <div className="form-group"><label className="form-label">password</label>
                    <input type="password" name="password" className="form-control" value={form.password} required onChange={handleInputChange} ></input></div>
                </div>
            <div className="card-footer row justify-content-center" ><input type="submit"  className="btn btn-lg btn-primary col-4" value="s'identifier" ></input></div>
            </form>
        </div>
    </div>
}